import { createSlice } from '@reduxjs/toolkit';

export const ItemValueSlice = createSlice({
  name: 'itemValue',
  initialState: {
    numsConditions: {},
  },
  reducers: {
    setNumCondition: (state, action) => {
      const { numId, arrConditionsIds } = action.payload;
      state.numsConditions[numId] = arrConditionsIds;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setNumCondition } = ItemValueSlice.actions;

export default ItemValueSlice.reducer;
